import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { OtherPlaceTextComponent } from 'src/app/_components/remote-action-step/other-place-text/other-place-text.component';
import { JobSectionsService } from 'src/app/_services/job-section/logic/job-section.service';
import { IMSId } from 'src/app/_model/ims-object';
import { JobSectionSelectRaStepComponent } from 'src/app/_components/remote-action-step/jobsection-select-ra-step/jobsection-select-ra-step.component';

@Injectable()
export class JobSectionRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private jobSectionsService: JobSectionsService, private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return JobSectionSelectRaStepComponent;
  }

  public isVisible(currentData: any): boolean {
    const sjobId: IMSId = currentData.next_sjobid != undefined ? {
      imsId: currentData.next_sjobid?.imsId,
      secondaryId: currentData.next_sjobid?.secondaryId,
      objRef: currentData.next_sjobid?.objRef
    } : undefined;
    return this.jobSectionsService.getJobSectionsByServicejobId(sjobId).length > 0 && currentData['jobsectionid'] == undefined
  }
}
